import {DatePicker, DatePickerProps  } from  'antd-mobile'
import React from 'react'
import { LabelItem } from '../Common/LabelItem';
import dayjs from 'dayjs';
import { FilterDatePickProps } from '@/component/FilterCommon/Filter';



export interface DatePickMobileProps extends DatePickerProps {
  startDay?:boolean
  endDay?:boolean
  format?:string
  placeholder:string
  picker?: FilterDatePickProps['picker']
  onChange?(date:dayjs.Dayjs,dateString:string):void
}


export const DatePickMobile:React.FC<DatePickMobileProps> = (props)=>{
  const { value,format = 'YYYY-MM-DD HH:mm:ss',startDay,endDay,picker = 'date', ...reset } = props;
  let placeholder = props.placeholder
  const [visible,setVisible] = React.useState(false);
  if(!placeholder){
    placeholder = startDay ? '开始时间' : endDay ? '结束时间' : '时间'
  }
  return <div>
    <LabelItem
      text={ value ? dayjs(value).format(format) : ''}
      label={placeholder}
      onClick={()=>{
        setVisible(true)
      }}
    />
    <DatePicker
      value={ value ? dayjs(value).toDate() : undefined}
      title={placeholder}
      visible={visible}
      onClose={() => {
        setVisible(false)
      }}
      {...reset}
      onConfirm={val => {
        let date = dayjs(val)
        let dateString = date.format(format)
        if(val){
          if(startDay){
            date = date.startOf(picker)
          }
          if(endDay){
            date = date.endOf(picker)
          }
          dateString = date.format(format)
        }
        props?.onChange?.(date,dateString)
        // Toast.show(val.toDateString())
      }}
    />
  </div>

}